<!--
안내 라벨 컴포넌트의 기본동작
 - 열기 / 닫기 상태관리
-->
<script>
    export default {
        props: {
            /**
             * (string)
             * 팝업 방향
             *  - 'top-left' : 상단 좌측기준정렬
             *  - 'top-right' : 상단 우측기준정렬
             */
            popupDirection: {
                type: String,
                default: 'top-left',
            },
        },
        data: function () {
            return {

                /**
                 * (bool)
                 * 팝업 display 상태
                 */
                viewDisplay: false,


            };
        },
        computed: {
        },
        methods: {
            /**
             * 팝업열기
             * @return void
             */
            openView() {
                this.viewDisplay = true;
            },

            /**
             * 팝업닫기
             * @return void
             */
            closeView() {
                this.viewDisplay = false;
            },
        },
    }
</script>